import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGrid from './components/HotGrid';
import FeatureGrid from './components/FeatureGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51吃瓜每日大赛 - 首页',
    description: '汇集全网热门吃瓜爆料与黑料视频，实时更新网红塌房、明星翻车、企业内幕等最新大瓜。',
    url: 'https://www.51chigua.com',
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51吃瓜每日大赛',
    url: 'https://www.51chigua.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.51chigua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <HotGrid />
        <FeatureGrid />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}